<template>
  <a-popover arrowPointAtCenter placement="left" trigger="click">
    <template #content>
      <Chrome :modelValue="color" @update:modelValue="changeColor"/>
    </template>
    <div class="color" :style="{backgroundColor:color }" v-if="show"></div>
    <slot v-else/>
  </a-popover>

</template>

<script setup="">
/* eslint-disable */
import {Chrome} from "@ckpack/vue-color";
import {debounce} from "lodash";


/* 属性 */
const props = defineProps({
  show: {
    required: false,
    default: false
  },
  color: {
    default: "#000000",
    required: false
  }
});

/* 事件 */
const emit = defineEmits(['update:color'])

/* 颜色面板控制 */
const changeColor = debounce((i) => {
  emit('update:color', i.hex8)
}, 50);


</script>


<style lang="scss">
.vc-chrome {
  box-shadow: none !important;
  border-radius: 0;
}
</style>

<style lang="scss" scoped>
.color {
  cursor: pointer;
  border-radius: 8px;
  width: 32px;
  height: 32px;
  border: 2px solid #e1e1e1;
}
</style>
